import React, { useState, useEffect, useContext } from "react";
import { NavigationBar, AppLayout } from "../components";
import ReactModal from "react-modal";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field } from "formik";
import { DashboardMenu } from "../components";
import * as Yup from "yup";

import { SiteContext } from "../context";

const validationSchema = Yup.object().shape({
  team: Yup.string().label("Team").required(),
  played: Yup.string().label("Games played").required(),
  wins: Yup.string().label("Wins").required(),
  draws: Yup.string().label("Draws").required(),
  losses: Yup.string().label("Losses").required(),
  goalsfor: Yup.string().label("Goals for").required(),
  goalsagaint: Yup.string().label("Goals against").required(),
  goalsdiff: Yup.string().label("Goals difference").required(),
  points: Yup.string().label("Points").required(),
});

const AdminLeagueTable = () => {
  const navigate = useNavigate();

  const { apiUrl, slugify, isMobile } = useContext(SiteContext);

  const userData = JSON.parse(localStorage.getItem("user"));

  const [items, setItems] = useState([]);
  const [updateItem, setUpdateItem] = useState({});
  const [itemSelected, setItemSelected] = useState({});
  const [userAction, setUserAction] = useState("update");
  const [msg, setMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    getTables();
  }, []);

  const getTables = () => {
    fetch(`${apiUrl}/api/league_table_manage.php?action=fetch`, {
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.status === 200) {
          setItems(res.rows);
        } else if (res.status === 400) {
          setMsg(res.msg);
          setTimeout(() => {
            setMsg("");
          }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    let formData = new FormData();

    formData.append("team", values.team);
    formData.append("gplayed", values.played);
    formData.append("gwins", values.wins);
    formData.append("glosses", values.losses);
    formData.append("gdraws", values.draws);
    formData.append("gfor", values.goalsfor);
    formData.append("gagainst", values.goalsagaint);
    formData.append("gdiff", values.goalsdiff);
    formData.append("gpts", values.points);
    formData.append("listing", values.id);
    formData.append("action", userAction);

    const sendType = "post";

    return fetch(`${apiUrl}/api/league_table_manage.php`, {
      method: sendType,
      body: formData,
    })
      .then((res) => res.json())
      .then(async (res) => {
        console.log(res);

        if (res.status === 200) {
          resetForm({});
          setSubmitting(false);
          setShowModal(false);
          setMsg(res.msg);
          setTimeout(() => {
            setMsg("");
            getTables();
          }, 3000);
        } else if (res.status === 400) {
          setErrorMsg(res.msg);
          setTimeout(() => {
            setErrorMsg("");
          }, 3000);
          setSubmitting(false);
        } else {
          alert(
            "Failure",
            "Error connection to the server please check your details and try again",
            [{ text: "Okay" }]
          );
        }
      })
      .catch((error) => {
        console.log("Api call error", error.message);
      });
  };

  const handleAdd = () => {
    setUserAction("create");
    setItemSelected({});
    setUpdateItem({});
    setShowModal(true);
  };

  const handleUpdate = (item) => {
    setUserAction("update");
    setUpdateItem(item);
    setShowModal(true);
  };

  const handleDelete = (eventid) => {
    setItemSelected(eventid);
    setShowDeleteModal(true);
  };

  const doDelete = (id) => {
    let formData = new FormData();

    formData.append("listing", id);
    formData.append("role", userData.role);
    formData.append("action", "delete");

    fetch(`${apiUrl}/api/league_table_manage.php`, {
      method: "post",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.status === 200) {
          setShowDeleteModal(false);
          getTables();
          setMsg(res.msg);
          setTimeout(() => {
            setMsg("");
          }, 3000);
        } else if (res.status === 400) {
          setErrorMsg(res.msg);
          setTimeout(() => {
            setErrorMsg("");
          }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <ReactModal
        isOpen={showDeleteModal}
        style={{
          overlay: {
            flex: 1,
            justifyContent: "center",
            alignContent: "center",
            position: "fixed",
            top: "10%",
            bottom: "10%",
            left: "25%",
            right: "25%",
            width: "50%",
            height: 250,
            backgroundColor: "rgba(255, 255, 255, 0.75)",
          },
          content: {
            position: "absolute",
            top: "20px",
            left: "20px",
            right: "20px",
            bottom: "20px",
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "20px",
          },
        }}
      >
        <div>
          <p className="h3 my-1 py-1">Confirm deletion</p>
          <p className="my-1 py-2">Action cannot be reversed!</p>
          <span
            className="btn btn-primary"
            onClick={() => doDelete(itemSelected)}
          >
            Confirm
          </span>{" "}
          <span
            className="btn btn-secondary"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </span>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={showModal}
        ariaHideApp={false}
        style={{
          overlay: {
            flex: 1,
            justifyContent: "center",
            alignContent: "center",
            position: "fixed",
            top: isMobile ? "2%" : "10%",
            bottom: isMobile ? "2%" : "10%",
            left: isMobile ? 0 : "25%",
            right: isMobile ? 0 : "25%",
            width: isMobile ? "100%" : "50%",
            height: isMobile ? "96%" : "80%",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
          },
          content: {
            position: "absolute",
            top: "10px",
            left: "10px",
            right: "10px",
            bottom: "10px",
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "20px",
          },
        }}
      >
        <div>
          <div className="d-flex justify-content-end">
            <span
              className="btn btn-secondary my-2"
              onClick={() => setShowModal(false)}
            >
              <i className="bi bi-x-square h4 text-white"></i>
            </span>
          </div>
          {errorMsg !== "" ? (
            <div className="mt-2">
              <span className="p-2 my-2 border border-danger text-danger">
                {errorMsg}
              </span>
            </div>
          ) : null}
          <Formik
            initialValues={{
              id: updateItem ? updateItem.flt_id : "",
              year: updateItem ? updateItem.flt_year : "",
              team: updateItem ? updateItem.flt_team : "",
              played: updateItem ? updateItem.flt_games_played : "",
              wins: updateItem ? updateItem.flt_games_win : "",
              draws: updateItem ? updateItem.flt_games_draw : "",
              losses: updateItem ? updateItem.flt_games_loss : "",
              goalsfor: updateItem ? updateItem.flt_goal_for : "",
              goalsagaint: updateItem ? updateItem.flt_goal_against : "",
              goalsdiff: updateItem ? updateItem.flt_goal_diff : "",
              points: updateItem ? updateItem.flt_points : "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              handleSubmit(values, { setSubmitting, resetForm });
            }}
          >
            {({
              handleChange,
              values,
              handleSubmit,
              errors,
              isValid,
              isSubmitting,
              handleBlur,
              touched,
              setFieldValue,
            }) => (
              <div>
                <form onSubmit={handleSubmit} encype="multipart/form-data">
                  <div className="container my-2">
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="year">Year</label>
                      </div>
                      <Field
                        as="select"
                        id="year"
                        name="year"
                        disabled
                        value={values.year}
                        onBlur={handleBlur("year")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      >
                        <option value="">Select...</option>
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                        <option value="2020">2020</option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option>
                        <option value="2023">2023</option>
                      </Field>

                      {touched.year && errors.year && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.year && errors.year}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="team">Team</label>
                      </div>
                      <Field
                        id="team"
                        name="team"
                        disabled
                        value={values.team}
                        placeholder="Team name"
                        onBlur={handleBlur("team")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.team && errors.team && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.team && errors.team}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="played">Games played</label>
                      </div>
                      <Field
                        id="played"
                        name="played"
                        value={values.played}
                        placeholder="Games played"
                        onBlur={handleBlur("played")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.played && errors.played && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.played && errors.played}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="wins">Wins</label>
                      </div>
                      <Field
                        id="wins"
                        name="wins"
                        value={values.wins}
                        placeholder="Wins"
                        onBlur={handleBlur("wins")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.wins && errors.wins && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.wins && errors.wins}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="draws">Draws</label>
                      </div>
                      <Field
                        id="draws"
                        name="draws"
                        value={values.draws}
                        placeholder="Draws"
                        onBlur={handleBlur("draws")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.draws && errors.draws && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.draws && errors.draws}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="losses">Losses</label>
                      </div>
                      <Field
                        id="losses"
                        name="losses"
                        value={values.losses}
                        placeholder="Losses"
                        onBlur={handleBlur("losses")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.losses && errors.losses && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.losses && errors.losses}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="goalsfor">Goals for</label>
                      </div>
                      <Field
                        id="goalsfor"
                        name="goalsfor"
                        value={values.goalsfor}
                        placeholder="Goals for"
                        onBlur={handleBlur("team")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.goalsfor && errors.goalsfor && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.goalsfor && errors.goalsfor}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="goalsagaint">Goals against</label>
                      </div>
                      <Field
                        id="goalsagaint"
                        name="goalsagaint"
                        value={values.goalsagaint}
                        placeholder="Goals against"
                        onBlur={handleBlur("goalsagaint")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.goalsagaint && errors.goalsagaint && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.goalsagaint && errors.goalsagaint}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="goalsdiff">Goals difference</label>
                      </div>
                      <Field
                        id="goalsdiff"
                        name="goalsdiff"
                        value={values.goalsdiff}
                        placeholder="Goals difference<"
                        onBlur={handleBlur("goalsdiff")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.goalsdiff && errors.goalsdiff && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.goalsdiff && errors.goalsdiff}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group my-1">
                      <div>
                        <label htmlFor="points">Points</label>
                      </div>
                      <Field
                        id="points"
                        name="points"
                        value={values.points}
                        placeholder="Points"
                        onBlur={handleBlur("points")}
                        autoCapitalize="none"
                        style={{
                          padding: 10,
                        }}
                        className="form-control"
                      />

                      {touched.points && errors.points && (
                        <div className="py-1">
                          <span className="text-danger">
                            {touched.points && errors.points}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    title={userAction}
                    disabled={!isValid || isSubmitting}
                    className="btn btn-primary capitalize"
                  >
                    {userAction}
                  </button>

                  <button
                    onClick={() => setShowModal(false)}
                    title="Cancel"
                    className="btn btn-secondary mx-2"
                  >
                    Cancel
                  </button>
                </form>
              </div>
            )}
          </Formik>
        </div>
      </ReactModal>
      <div>
        <div className="row">
          <div className="col-md-2 bg-light">
            <DashboardMenu />
          </div>
          <div className="col-md-10">
            <div className="container my-2">
              <h3>
                League tables |{" "}
                <Link to="/adminmatchresults">Match results</Link> |{" "}
                <Link to="/adminleagueteams">League teams</Link>
              </h3>
              <div className="my-2 d-flex justify-content-between">
                <div className="align-items-center">
                  {msg !== "" ? (
                    <div className="p-2">
                      <span className="p-2 border border-info text-dark">
                        {msg}
                      </span>
                    </div>
                  ) : null}
                  {errorMsg !== "" ? (
                    <div className="p-2">
                      <span className="p-2 border border-info text-dark">
                        {errorMsg}
                      </span>
                    </div>
                  ) : null}
                </div>
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleAdd()}
                  >
                    New team
                  </button>
                </div>
              </div>
              <div className="bg-slate-300 font-bold p-2 flex justify-between">
                <div className="w-[30px]">Year </div>
                <div className="w-[100px]">Team </div>
                <div className="py-1">GP </div>
                <div className="py-1">W </div>
                <div className="py-1">D </div>
                <div className="py-1">L </div>
                <div className="py-1">GF </div>
                <div className="py-1">GA</div>
                <div className="py-1">GD </div>
                <div className="py-1">Pts </div>
                <div className="w-[30px]"></div>
              </div>

              {items.map((item, i) => {
                return (
                  <div key={i} className="flex px-1 py-2 justify-between">
                    <div className="w-[30px]">{item.flt_year} </div>
                    <div className="w-[100px]">{item.flt_team} </div>
                    <div className="py-1">{item.flt_games_played} </div>
                    <div className="py-1">{item.flt_games_win} </div>
                    <div className="py-1">{item.flt_games_draw} </div>
                    <div className="py-1">{item.flt_games_loss} </div>
                    <div className="py-1">{item.flt_goal_for} </div>
                    <div className="py-1">{item.flt_goal_against} </div>
                    <div className="py-1">{item.flt_goal_diff} </div>
                    <div className="py-1">{item.flt_points} </div>
                    <div className="w-[50px]">
                      <a onClick={() => handleUpdate(item)}>
                        <i className="bi bi-pencil text-dark h4"></i>
                      </a>
                      <a onClick={() => handleDelete(item.flt_id)}>
                        <i className="bi bi-trash text-danger h4"></i>
                      </a>{" "}
                    </div>
                  </div>
                );
              })}

              <p className="text-slate-500 small">W=3,D=1,L=0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLayout(AdminLeagueTable);
